import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

import { RoleService } from "../../Shared/role.service";
import { ConfirmationdialogService } from "../../../utility/shared/confirmationdialog.service";
import { ToasterserviceService } from "../../../utility/shared/toasterservice.service";
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { Toastpayload } from "../../../utility/shared/toastpayload";

@Component({
  selector: 'app-rolelist',
  templateUrl: './rolelist.component.html',
  styleUrls: ['./rolelist.component.css']
})
export class RolelistComponent implements OnInit {

  displayedColumns: string[] = ['No', 'Code', 'Role Name', 'Remarks', 'New'];

  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  toast: Toastpayload;
  addForm: FormGroup;

  constructor(private router: Router, private route: ActivatedRoute,
    private roleService: RoleService, public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private toasterserviceService: ToasterserviceService,
    private confirmationdialogService: ConfirmationdialogService,) { }

  ngOnInit() {
    this.getRoleList();
    this.dataSource.paginator = this.paginator;
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  getRoleList() {

    this.roleService.FetchRoleList()
      .toPromise()
      .then(data => {
        this.dataSource.data = data;
      })
      .catch(err => { console.log(err) });
  }

  public AddNewRole() {
    this.router.navigate(['/role']);
  }

  EditRole(role: any) {
    this.router.navigate(['/role', role.Id]);
  }

  //Deletion employee role 
  DeleteRole(role: any) {

    // assigining the employee Id and details
    this.addForm = this.formBuilder.group({
      frmId: [role.Id],
      frmRoleName:[''],
      frmCode:[],
      frmRemarks: [],
      frmActive: [true],
      frmFlag: [2],
    });

    this.toast = {
      message: "Staff roles have been deleted",
      title: 'Staff roles!',
      ic: {
        timeOut: 3000,
        closeButton: true,
      } as IndividualConfig,
      type: 'error',
    };

    let title: string = "Confirmation";
    let message: string = "If you continue, Staff roles will be removed. Are you sure? ";
    let btnOkText: string = "Yes";
    let btnCancelText: string = 'No, Exit';


    this.confirmationdialogService.openModalWithClass(title, message, btnOkText, btnCancelText)
      .subscribe(confirmed =>
      // console.log('User confirmed:', confirmed)
      {
        if (confirmed == true) {

          this.roleService.IUDRole(this.addForm).toPromise()
            .then(data => {
              this.reload();
            })

        }
        else {
          this.toast.message = 'You are cancelled the staff roles deletion.!'
          this.toast.type = 'warning';
          this.toasterserviceService.showToast(this.toast);
        }
      });
  }

  reload() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(['./'], { relativeTo: this.route });
  }


}
